<template>
  <div id="AvalibilityProfile">
    <h2 class="theme_name">
      <font-awesome-icon icon="network-wired"/>
      {{ (!selectedId || selectedId === 8999) ? 'Region' : namesFromGeotype[geotype].singularName}} Availability
    </h2>
    <div style="padding: 2px; margin: 2px; font-size: small">
      <div>
        <AvailabilityAboutPage v-bind:selectedId="selectedId" class="no-print"/>
        Broadband availability (25/3 Mbps or faster) shows estimated residential fixed, non-mobile terrestrial service.
      </div>
    </div>
    <div id="charts" ref="charts">

          <div>
            <div>
              <bigNum
                v-bind:format="formatPercent3sig"
                v-bind:color="'#1f5f94'"
                v-bind:num="(totalInd.hh_2sped + totalInd.hh_3sped + totalInd.hh_4sped)"
                v-bind:formatPercent="formatPercentOnBigNum"
                v-bind:numPercentNum="(totalInd.hh_2sped + totalInd.hh_3sped + totalInd.hh_4sped) / totalInd.tot_hh*100"
              >
                households with broadband available
              </bigNum>
              <bigNum
                v-bind:format="formatPercent3sig"
                v-bind:color="'#1f5f94'"
                v-bind:num="(totalInd.hh_3sped + totalInd.hh_4sped)"
                v-bind:formatPercent="formatPercentOnBigNum"
                v-bind:numPercentNum="(totalInd.hh_3sped + totalInd.hh_4sped) / totalInd.tot_hh*100"
              >
                households with fast broadband available
              </bigNum>
              <bigNum
                v-bind:format="formatPercent3sig"
                v-bind:color="'#1f5f94'"
                v-bind:num="(totalInd.hh_0sped + totalInd.hh_1sped)"
                v-bind:formatPercent="formatPercentOnBigNum"
                v-bind:numPercentNum="(totalInd.hh_0sped + totalInd.hh_1sped) / totalInd.tot_hh*100"
              >
                households unserved by broadband
              </bigNum>
            </div>
            <barChart v-bind:chartData="numProvChart[0]"
                      v-bind:options="numProvChart[1]"
                      v-bind:style="{width: '98%', height: '30vh', position: 'relative', border: 'solid 1px lightgray'}"/>
            <barChart v-bind:chartData="maxInternetSpeedChart[0]"
                      v-bind:options="maxInternetSpeedChart[1]"
                      v-bind:style="{width: '98%', height: '30vh', position: 'relative', border: 'solid 1px lightgray'}"/>
            <barChart v-bind:chartData="fbbRaceChart[0]"
                      v-bind:options="fbbRaceChart[1]"
                      v-bind:style="{width: '98%', height: ((this.geotype !== 'BlockGroup') || this.selectedId === null) ? '30vh' : '10vh', position: 'relative', border: 'solid 1px lightgray'}"/>
            <div v-if="!((this.geotype !== 'BlockGroup') || this.selectedId === null)">The above chart cannot be displayed at this geography.</div>
          </div>
            <div id="stats">
        <div>
          <h2>{{selectedName}} Demographics</h2>
          <div class="">{{'Total Households: '+ format(totalInd.households_21)}}</div>
          <div class="subgroup">{{'with Children: '+ format(totalInd.e_hhwithchildren_21)}}</div>
          <div class="subgroup">{{'with Seniors: '+ format(totalInd.e_hhwithseniors_21)}}</div>
          <div class="">{{'Avg Household Size: '+ formatOnLegend(totalInd.eavghouseholdsize_21)}}</div>
          <div class="">{{'Median Household Income: $'+ format(totalInd.emedhhinc_21)}}</div>
          <div class="">{{'Households in Poverty: '+ formatPercentOnBigNum(totalInd.ehouseholdsinpoverty_21 / totalInd.households_21)}}</div>
          <div class="">{{'Total Population: '+ format(totalInd.totalpop_21)}}</div>
          <div class="">{{'Household Population: '+ format(totalInd.hhpop_21)}}</div>
          <div class="subgroup">{{'White: '+ format(totalInd.hhpopnhwhite_21)}}</div>
          <div class="subgroup">{{'Black: '+ format(totalInd.hhpopblk_21)}}</div>
          <div class="subgroup">{{'Asian: '+ format(totalInd.hhpopasian_21)}}</div>
          <div class="subgroup">{{'Hispanic: '+ format(totalInd.hhpophisp_21)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3'
import barChart from "./charts/barChart.vue";
import AvailabilityAboutPage from "./AvailabilityAboutPage.vue";
import bigNum from "./charts/bigNum.vue";

export default {
  name: 'AvalibilityProfile',
  components: {barChart, bigNum, AvailabilityAboutPage},
  props: [
    'selectedId',
    'selectedName',
    'allGeogData',
    'regionData',
    'namesFromGeotype',
    'geotype',
  ],
  methods: {
    shareURL: function () {
      let textarea = document.createElement('textarea');
      textarea.textContent = window.location.href;
      textarea.style.position = 'fixed';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy')
    },
    format: d3.format(',d'),
    formatOnLegend: d3.format('.2f'),
    formatPercentOnLegend: d3.format('.00%'),
    formatPercentOnBigNum: d3.format('.1f'),
    formatPercent2dec: d3.format('.2%'),
    formatPercent2sig: d3.format(".2s"),
    formatPercent3sig: d3.format(".3s"),
  },
  computed: {
    numProvChart: function () {
      return [{
        labels: ['4', '3', '2', '1', '0'],
        datasets: [
          {
            backgroundColor: [
              'rgb(32, 135, 140)',
              'rgb(106, 173, 122)',
              'rgb(189, 230, 112)',
              'rgb(255, 255, 128)',
              'rgb(255,255,255)'],
            borderColor: 'black',
            backgroundOpacity: 0.7,
            borderWidth: 1,
            data: [this.totalInd.hh_4fbbp, this.totalInd.hh_3fbbp, this.totalInd.hh_2fbbp,this.totalInd.hh_1fbbp, this.totalInd.hh_0fbbp],
          },
        ],
      }, {
        title: {
          text: 'Households by Number of Broadband Providers',
          fontSize: 18,
          fontColor: 'black',
          position: 'top',
          display: true,
        },
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';
              label += this.format(tooltipItem.yLabel);
              label += (' (' + this.formatPercentOnLegend(tooltipItem.yLabel / this.totalInd.tot_hh) + ')');
              return label;
            },
          },
        },
        plugins: {
          datalabels: {
            color: 'black',
            textShadowBlur: 6,
            textShadowColor: 'white',
            display: false,
            font: {
              weight: 'bold',
            },
            formatter: this.format,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            display: true,
            ticks: {
              beginAtZero: true,
              callback: (value) => {
                return this.format(value);
              },
            },
          }],
        },
      }]
    },
    maxInternetSpeedChart: function () {
      return [{
        labels: ['1 Gbps', '100M x 10M', '25M x 3M', '10M x 1M', 'No Service'],
        datasets: [
          {
            backgroundColor: [
              'rgba(0, 128, 128, 0.7)',
              'rgba(112, 164, 148, 0.7)',
              'rgba(180, 200, 168, 0.7)',
              'rgba(238, 170, 132, 0.7)',
              'rgba(202, 86, 44, 0.7)'],
            borderColor: 'black',
            backgroundOpacity: 0.7,
            borderWidth: 1,
            data: [this.totalInd.hh_4sped, this.totalInd.hh_3sped, this.totalInd.hh_2sped,this.totalInd.hh_1sped, this.totalInd.hh_0sped],
          },
        ],
      }, {
        title: {
          text: 'Households by Max Internet Speed',
          fontSize: 18,
          fontColor: 'black',
          position: 'top',
          display: true,
        },
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';
              label += this.format(tooltipItem.yLabel);
              label += (' (' + this.formatPercentOnLegend(tooltipItem.yLabel / this.totalInd.tot_hh) + ')');
              return label;
            },
          },
        },
        plugins: {
          datalabels: {
            color: 'black',
            textShadowBlur: 6,
            textShadowColor: 'white',
            display: false,
            font: {
              weight: 'bold',
            },
            formatter: this.format,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            display: true,
            ticks: {
              beginAtZero: true,
              callback: (value) => {
                return this.format(value);
              },
            },
          }],
        },
      }]
    },
    fbbRaceChart: function () {
      let withBB = []
      let withoutBB = []

      if ((this.geotype !== 'BlockGroup') || this.selectedId === null) {
        withBB = [this.totalInd.wht_fbb / this.totalInd.wht_pop, this.totalInd.blk_fbb / this.totalInd.blk_pop, this.totalInd.hsp_fbb / this.totalInd.hsp_pop, this.totalInd.asn_fbb / this.totalInd.asn_pop]
        withoutBB = [1 - (this.totalInd.wht_fbb / this.totalInd.wht_pop), 1 - (this.totalInd.blk_fbb / this.totalInd.blk_pop), 1 - (this.totalInd.hsp_fbb / this.totalInd.hsp_pop), 1 - (this.totalInd.asn_fbb / this.totalInd.asn_pop)]
      }

      return [{
        labels: ['White', 'Black', 'Hispanic', 'Asian'],
        datasets: [
          { //#5F4690,#1D6996,#38A6A5,#0F8554,#73AF48,#EDAD08,#E17C05,#CC503E,#94346E,#6F4070,#994E95,#
            label: 'With Broadband',
            backgroundColor: ['#0F8554', '#EDAD08', '#CC503E', '#94346E'],
            data: withBB,
          }, {
            label: 'Without Broadband',
            backgroundColor: ['#cdcdd6', '#cdcdd6', '#cdcdd6', '#cdcdd6'],
            data: withoutBB,
          },
        ],
      }, {
        title: {
          text: 'Household Population with Broadband Available',
          fontSize: 18,
          fontColor: 'black',
          position: 'top',
          display: true,
        },
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';
              label += ' ' + this.formatPercentOnLegend(tooltipItem.yLabel);
              return label;
            },
          },
        },
        plugins: {
          datalabels: {
            color: 'black',
            textShadowBlur: 6,
            textShadowColor: 'white',
            display: true,
            font: {
              weight: 'bold',
            },
            formatter: this.formatPercentOnLegend,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [{
            display: false,
            stacked: true,
            ticks: {
              beginAtZero: true,
              callback: (value) => {
                return this.formatPercentOnLegend(value);
              },
            },
          }],
        },
      }]
    },
    totalInd: function () {
      if (!this.selectedId && !this.regionData) {
        return {}
      }
      let sel = (this.selectedId && this.allGeogData.find(geo => geo.geoid === this.selectedId))
      if (sel) {
        return sel
      }
      return this.regionData
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#AvalibilityProfile {
  grid-column: 1;
  grid-row: 2;
  background: #fefefe;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content auto;
  min-height: 0;
}

#charts {
  overflow-y: auto;
  background: #fefefe;
  position: relative;
}

#charts > div {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 5px;
  row-gap: 5px;
  margin: 2px;
  padding: 7px;
  border: solid 2px #011f4a;
  border-radius: 10px;
}

div#stats {
  grid-template-columns: 1fr;
}

#stats {
  font-size: small;
}

.subgroup {
  margin-left: 15px;
}

.bigNum {
  font-size: xx-large;
  font-weight: bolder;
}

h2, h3, h4, h5 {
  margin: 0;
}

div a {
  font-size: medium;
  color: #0f2d53;
  font-weight: bold;
  vertical-align: middle;
}

.controls {
  z-index: 3;
  padding: 4px;
  text-align: center;
}

.col_1_2 {
  grid-column-start: 1;
  grid-column-end: 1;
}

.col_3_wide {
  grid-column-start: 1;
  grid-column-end: 4;
}

.geoname {
  font-size: 1.9em;
  margin-left: 5px;
}

.theme_name {
  margin: 2px;
  font-size: 1.6em;
  font-weight: bolder;
  text-align: center;
  color: white;
  background-color: #011f4a;
  border: solid 2px #011f4a;
  border-radius: 10px;
}

.share {
  float: right;
  background: rgba(107, 153, 91, 0.7);
  border-radius: 4px;
  border-width: 1px;
  border-color: #9aa5a9;
}

.share:active {
  background: #9aa5a9;
}

.info {
  content: '';
  cursor: pointer;
  position: absolute;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill='%23333333' fill-rule='evenodd' d='M4,10a6,6 0 1,0 12,0a6,6 0 1,0 -12,0 M9,7a1,1 0 1,0 2,0a1,1 0 1,0 -2,0 M9,10a1,1 0 1,1 2,0l0,3a1,1 0 1,1 -2,0'/%3E %3C/svg%3E");
  background-color: rgba(255, 255, 255, 0.5);
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  border-radius: 12px;
}

/deep/ .my-tooltip {
  display: block !important;
  z-index: 1;
  font-size: small;
  max-width: 90%;
}

/deep/ .my-tooltip strong {
  font-size: medium;
}

/deep/ .my-tooltip small {
  color: #9aa5a9;
  font-size: small;
}

/deep/ .my-tooltip .my-tooltip-inner {
  background: #292424;
  color: white;
  opacity: 0.95;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

/deep/ .my-tooltip .my-tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #292424;
  opacity: 0.95;
  z-index: 1;
}

/deep/ .my-tooltip[x-placement^="top"] {
  margin-bottom: 10px;
}

/deep/ .my-tooltip[x-placement^="top"] .my-tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 10px);
  margin-top: 0;
  margin-bottom: 0;
}

/deep/ .my-tooltip[x-placement^="bottom"] {
  margin-top: 10px;
}

/deep/ .my-tooltip[x-placement^="bottom"] .my-tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 10px);
  margin-top: 0;
  margin-bottom: 0;
}

/deep/ .my-tooltip[x-placement^="right"] {
  margin-left: 10px;
}

/deep/ .my-tooltip[x-placement^="right"] .my-tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

/deep/ .my-tooltip[x-placement^="left"] {
  margin-right: 10px;
}

/deep/ .my-tooltip[x-placement^="left"] .my-tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

/deep/ .my-tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: #292424;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, .1);
}

/deep/ .my-tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

/deep/ .my-tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

/deep/ .my-tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}

.single-ind {
  text-align: center;
}

.comm_dropdown {
  border-color: #f5f5f5;
  border-radius: 10px;
  max-width: 100%;
  font-size: large;
  margin-left: 3px;
}

.comm_dropdown:focus {
  outline: 0;
  border-color: black;
}

.comm_dropdown option {
  font-size: 0.8rem;
}

/deep/ .mapboxgl-ctrl-group > button {
  width: 29px;
  height: 29px;
}


/deep/ .legendColor {
  display: grid;
}

/deep/ .legendNames {
  display: grid;
}


@media (max-width: 576px), print {
  #charts {
    overflow-y: unset;
  }

  #AvalibilityProfile {
    grid-column: 1;
    grid-row: 3;
    overflow-y: unset;
  }

  .distribution {
    page-break-before: always;
  }
}

@media (max-width: 970px) {
  .comm_dropdown {
    width: 100%;
  }
}
</style>
